import { IAppState } from '../../redux';
import { selectIsPublishToHiddenBase } from '../publishAvailable';

export function selectIsPublicationAvailable(state: IAppState): boolean {
  const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

  if (isPublishToHiddenBase) {
    return true;
  }

  const { isPurchaseAvailable } = state.checkoutInfo;

  return isPurchaseAvailable;
}
